// removed by extract-text-webpack-plugin
module.exports = {"editor":"tP1Ms","toolbar":"_3ieR6","toolbar-tooltip":"_2tNKj","grey-cross":"_20kex","toolbar-icon":"ZBaha","is-active":"_3OjF9","toolbar-icon-disabled":"_3vVQv","toolbar-icon-tooltip":"DwlRO","button-inner-wrapper":"y72rJ","button-wrapper":"BPIlG","quote":"_2Fu08","quote-marks":"_22jDy","quote-container":"_1qEQq","tooltip":"_2uaSj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RichEditor/RichEditor.scss
// module id = ./src/components/RichEditor/RichEditor.scss
// module chunks = 4